import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";


export type LoginPayload = {
  username: string;
  password: string;
}


export interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

// Shape depends on backend; keep it flexible but non-any.
export type MeResponse = {
    id: number,
    username: string,
    email: string,
    first_name: string,
    last_name: string,
    is_active: boolean,
    is_superuser: boolean,
    role_id: number,
    role_name: string,
    last_login: string,
    created_at: string
}

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await axiosInstance.post<LoginResponse>(
    `${import.meta.env.PROD ? endpoints().auth.login : `/api/v1${endpoints().auth.login}`}`,
    payload,
  );
  return response.data;
};

export const logout = async () => {
  const response = await axiosInstance.post(`${import.meta.env.PROD 
    ? endpoints().auth.logout 
    : `/api/v1${endpoints().auth.logout}`}`);
  return response.data;
};

export const getMe = async () => {
  const response = await axiosInstance.get<MeResponse>(`${import.meta.env.PROD 
    ? endpoints().auth.me 
    : `/api/v1${endpoints().auth.me}`}`);
  return response.data;
};